import CandidateSearchForFilter from './CandidateSearchForFilter.container';

export default CandidateSearchForFilter;
